const getWebhookData = () => {
  const webhookColumns = [
    {
      Header: "Action Name",
      accessor: "name",
      sortable: false,
    },
    {
      Header: "Request URL",
      accessor: "request.url",
      sortable: false,
    },
  ];

  return { webhookColumns };
};

export default getWebhookData;
